function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_776_526)"
}, /*#__PURE__*/React.createElement("rect", {
  y: 0.396484,
  width: 32,
  height: 32,
  rx: 8,
  fill: "#000000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.8099 10.4665L22.5599 11.6565C22.5083 11.6974 22.4689 11.7517 22.446 11.8134C22.4231 11.8751 22.4175 11.9419 22.4299 12.0065V20.7765C22.4161 20.8422 22.4221 20.9104 22.447 20.9727C22.4719 21.035 22.5147 21.0885 22.5699 21.1265L23.7799 22.3265V22.5865H17.6499V22.3165L18.9199 21.0965C19.0399 20.9765 19.0399 20.9365 19.0399 20.7465V13.6665L15.5299 22.5565H15.0499L10.9999 13.6665V19.6665C10.9798 19.7892 10.9892 19.9149 11.0275 20.0332C11.0657 20.1515 11.1317 20.2589 11.2199 20.3465L12.8599 22.3465V22.6065H8.17993V22.2965L9.81993 20.2965C9.90706 20.2085 9.97165 20.1006 10.0082 19.9823C10.0448 19.8639 10.0522 19.7384 10.0299 19.6165V12.7365C10.0421 12.6416 10.0302 12.5451 9.99522 12.4559C9.96026 12.3668 9.90342 12.2879 9.82993 12.2265L8.37993 10.4665V10.2065H12.9099L16.4099 17.8765L19.4899 10.2065H23.8099V10.4665Z",
  fill: "#d4c3da"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_776_526"
}, /*#__PURE__*/React.createElement("rect", {
  y: 0.396484,
  width: 32,
  height: 32,
  rx: 8,
  fill: "white"
})));

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.940a2ae9.svg";
export { ForwardRef as ReactComponent };